export enum CartModalKind {
	OrderError = "OrderError",
	OrderAlreadyExists = "OrderAlreadyExists",
	ClearForSubscription = "ClearForSubscription",
	ClearForProducts = "ClearForProducts",
	FfcMembersOnly = "FfcMembersOnly",
}
